// extracted by mini-css-extract-plugin
module.exports = {"container-70":"Container70_container-70__KGeNb","container-70__col":"Container70_container-70__col__Oe_Ua"};